module.exports = __webpack_public_path__ + "8a5356e9/img/print-icon.d8dbbca5.svg";